import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ShieldLockIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 14V21.0001H19.9999V14H12ZM23 2.99997C20.39 2.42997 18.05 1.72994 16 1C13.95 1.72994 11.61 2.42997 8.99999 2.99997C6.85002 3.46994 4.84003 3.78991 3 4V13.98C3 20.7 6.91002 26.8 13 29.62L16 31L19 29.62C25.09 26.8 29 20.7001 29 13.98V4C27.1601 3.79 25.1501 3.46994 23 2.99997ZM22 21C22 22.0999 21.1 22.9999 20 22.9999H12C10.9 22.9999 10 22.0999 10 21V13.9999C10 12.9 10.9 12 12 12V10.9999C12 8.78988 13.79 6.99991 16 6.99991C18.21 6.99991 20 8.78988 20 10.9999V12C21.1001 12 22 12.9 22 13.9999V21ZM12 14V21.0001H19.9999V14H12ZM18 10.9999C18 9.89997 17.1 8.99997 16 8.99997C14.9 8.99997 14 9.89997 14 10.9999V12H18.0001L18 10.9999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
